<template>
  <div>
    <v-checkbox
      v-model="type"
      label="red"
      color="blue"
      value="red"
      hide-details
    ></v-checkbox>
  </div>
</template>

<script>
export default {
  props: ["filters"],
  data() {
    return {
      rating: 4,
      range: [0, 50],
    };
  },
  watch: {},
  methods: {},
  mounted() {
    // this.category = JSON.parse(this.category);
    console.log("mounted filters");
  },
  created() {
    // console.log(JSON.parse(this.category));
  },
  computed: {},
};
</script>

<style>
</style>
